module.exports = __webpack_public_path__ + "37818172b0bfbc38c0a94985fa9908c5.pdf";